import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { ButtonAnchor } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { CATALOGO_URL } from '../../data/brand';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../../utils/vehicles';
export function CtaFinal() {
  return <section className="border-t border-line/60 bg-ink py-16 md:py-24" data-id="element-216" data-mp="1ffcz82v4n2ii">
      <div className="mx-auto w-full max-w-7xl px-5 md:px-8" data-id="element-217" data-mp="1fi8vznv8nl5d">
        <Reveal data-id="element-218" data-mp="1te2vjga4gy5t">
          <div className="relative overflow-hidden rounded-3xl border border-neon/45 bg-surface2/30 px-7 py-12 text-center backdrop-blur-md md:px-12 md:py-16" style={{
          boxShadow: '0 0 70px -28px rgba(31,123,255,0.9)'
        }} data-id="element-219" data-mp="1tduf5eesjapv">
            <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-px bg-neon/70" data-id="element-220" data-mp="1y643wr4664qk" />
            <h2 className="mx-auto max-w-3xl text-3xl font-black leading-[1.08] tracking-tight text-white md:text-[46px]" data-id="element-221" data-mp="2c42ctgzq18yo">
              Tu próximo auto te está esperando
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-mist md:text-lg" data-id="element-222" data-mp="n7evc3yce7rr">
              Consultanos hoy y recibí asesoramiento personalizado para encontrar el
              vehículo ideal para vos.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-223" data-mp="1153g7bsetewt">
              <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="lg" data-id="element-224" data-mp="1130dbr65rrao">
                <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-225" data-mp="1a4qg1t5hqcnr" />
                Hablar por WhatsApp
              </ButtonAnchor>
              <ButtonAnchor href={CATALOGO_URL} size="lg" data-id="element-226" data-mp="1ez457dtk7njz">
                Ver vehículos disponibles
              </ButtonAnchor>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}